module.exports = __webpack_public_path__ + "img/logo.89dccc05.png";